<template>
    <div class="category-not-found">
        <h1>Oops! That category doesn't exist.</h1>
        <router-link :to="linkToCategoryIndex">
            Back to the category index
        </router-link>
    </div>
</template>

<script>
    // ForumCategoryNotFound: a 404 page for categories.

    export default {
        computed: {
            linkToCategoryIndex() {
                return {
                    name: 'forum-categories',
                };
            },
        },
    }
</script>

<style lang="scss" scoped>
    h1 {
        font-size: 39px;
        margin: 0 0 30px;
    }

    a {
        color: #33ccff;
    }
</style>



// WEBPACK FOOTER //
// category-not-found.vue?67036ece